import { fetchWrapper } from '@/helpers'
const ruta = process.env.VUE_APP_ROOT_API

export default class RecursoService {
  async getAll() {
    return await fetchWrapper.get(`${ruta}/recursos`)
  }

  async create(datos) {
    return await fetchWrapper.post(`${ruta}/recursos`, datos)
  }

  async update(id, datos) {
    return await fetchWrapper.put(`${ruta}/recursos/${id}`, datos)
  }

  async delete(id) {
    return await fetchWrapper.delete(`${ruta}/recursos/${id}`)
  }
}
